import { render, staticRenderFns } from "./TESTROUTE.vue?vue&type=template&id=6122326e&"
import script from "./TESTROUTE.vue?vue&type=script&lang=js&"
export * from "./TESTROUTE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports